import { Component, inject } from '@angular/core';
import { NgbToastModule } from '@ng-bootstrap/ng-bootstrap';
import { ToastsService } from '@app/shared/components/toasts/toasts.service';

@Component({
  selector: 'app-toasts',
  standalone: true,
  imports: [NgbToastModule],
  templateUrl: './toasts.component.html'
})
export class ToastsComponent {
  toastsService = inject(ToastsService);
}
